export const T = {
  en_GB: {
    title: "Review screening",
    description: (name: string) => `Record a compliance decision on the findings for ${name}.`,
    findings: "Findings",
    pep: "PEP",
    sanctioned: "Sanctioned",
    yes: "Yes",
    no: "No",
    notAssessed: "Not assessed",
    subjectLine: (name: string) => `PEP screened on the representative: ${name}`,
    decision: "Decision",
    accepted: "Accept",
    acceptedHint: "Reviewed — the client may proceed",
    blocked: "Block",
    blockedHint: "Reviewed — the client must not proceed",
    notAMatch: "Not a match",
    notAMatchHint: "None of the listings above is this client",
    note: "Reason",
    notePlaceholder: "Why this decision was made",
    noteRequired: "Required. The decision applies to the findings above and lapses if they change.",
    previous: (p: { decision: string; by: string; at: string }) =>
      `Previously ${p.decision} by ${p.by} on ${p.at}`,
    previousStale: (p: { decision: string; by: string; at: string }) =>
      `Previously ${p.decision} by ${p.by} on ${p.at} — findings have changed since`,
    noMatchesToRuleOut: "There are no matched individuals to rule out",
    matchesLeft: (count: number) =>
      `Every match must be dismissed to close this as not a match (${count} left)`,
    cancel: "Cancel",
    save: "Save",
  },
  nb_NO: {
    title: "Vurder screening",
    description: (name: string) => `Registrer en compliance-beslutning på funnene for ${name}.`,
    findings: "Funn",
    pep: "PEP",
    sanctioned: "Sanksjonert",
    yes: "Ja",
    no: "Nei",
    notAssessed: "Ikke vurdert",
    subjectLine: (name: string) => `PEP sjekket på representanten: ${name}`,
    decision: "Beslutning",
    accepted: "Godkjenn",
    acceptedHint: "Vurdert — kunden kan fortsette",
    blocked: "Blokker",
    blockedHint: "Vurdert — kunden skal ikke fortsette",
    notAMatch: "Ikke treff",
    notAMatchHint: "Ingen av oppføringene ovenfor er denne kunden",
    note: "Begrunnelse",
    notePlaceholder: "Hvorfor denne beslutningen ble tatt",
    noteRequired: "Påkrevd. Beslutningen gjelder funnene over og bortfaller hvis de endres.",
    previous: (p: { decision: string; by: string; at: string }) =>
      `Tidligere ${p.decision} av ${p.by} den ${p.at}`,
    previousStale: (p: { decision: string; by: string; at: string }) =>
      `Tidligere ${p.decision} av ${p.by} den ${p.at} — funnene har endret seg siden`,
    noMatchesToRuleOut: "Det finnes ingen treff på personer å utelukke",
    matchesLeft: (count: number) =>
      `Alle treff må avvises for å lukke dette som ikke treff (${count} igjen)`,
    cancel: "Avbryt",
    save: "Lagre",
  },
} as const;
